import { chat, isElectron, room } from "../../libs/roomnew";

export default class Main{
    constructor(){
        this.chatWindow=null;
        this.events={};
        this.allowedOrigins=[
            'https://web3.kinetx.co',
            'https://pre-prod.kinetx.co',
            'https://kino.live',
            'file://'
        ];
        this.myorigin=`${isElectron ? api.global.app_url : window.location.protocol+'://'+window.location.hostname}`
        this.closeModalBtn = `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg>`;

    };
    initializeMessages(){
        window.addEventListener('message',(event)=>{
            if (!this.allowedOrigins.includes(event.origin)){
                console.error(`${event.origin} is not an allowed origin`);
                return
            }
            let data=event.data;
            // console.log("Received message from popup window",event)
            if(data.eventName && this.events[data.eventName]){
                this.events[data.eventName].call(this, data);
            }
        });

    };

    listenMain(eventName,callback){
        this.events[eventName]=callback;
    };

    sendMessage(message){
        if(!this.chatWindow){return}
        this.chatWindow.postMessage(message,"*");
    }
    sendInitialChatData(){
        let participants=room.getParticipants().map(p=>{return {guest_id:p.getProperty('guest_id'),_displayName:p.getDisplayName(),pid:p.getId()}});
        if (!chat.selectedChatId) {
            chat.selectedChatId = chat.getGroupId([]);
            chat.lastSelectedChatId = chat.selectedChatId;
        }
        this.chatWindow.postMessage({
            eventName:'initialMessage',
            myUniqueId:chat.myUniqueId,
            participants:participants,
            participantNames:chat.participantNames,
            selectedChatId:chat.selectedChatId,
            chatButtonNotifications:chat.chatButtonNotifications,
            groupNotifications:chat.groupNotifications,
            user_id: USER_ID,
            user_name: MY_NAME,
        },"*");
    }

    isChatPopupOpen(){
        return this.chatWindow && !this.chatWindow.closed
    };

    openChatPopup(){
        console.log("opening chat popup")
        if(this.isChatPopupOpen()){
            this.chatWindow.focus();
            return;
        }
        this.chatWindow = window.open(`${isElectron ? api.global.app_url : '' }/chat/kino/${ROOM_NAME}/popup`, 'Kino Chat',
        'width=650,height=700' +
        ',menubar=0' +
        ',toolbar=0' +
        ',status=0' +
        ',scrollbars=1' +
        ',resizable=1');
        if(!this.chatWindow){
            this.showPopupBlockedModal();
            return
        }
        this.chatWindow.addEventListener('unload', (event) => {
            if(this.chatWindow && this.chatWindow.closed){
                this.onChatPopupClosed();
            }
          });

        this.listenMain('chat-popup-ready',(data)=>{
            this.sendInitialChatData();
        })
    };
    closeChatPopup(){
        if(this.isChatPopupOpen()){
            console.trace("chat popup closed")
            this.chatWindow.close();
            this.chatWindow=null;
        }
    };
    onChatPopupClosed(){
        console.log("On chat popup closed")
        this.chatWindow=null;

    };
    setModalShown(){
        localStorage.setItem('allow-chat-popup-modal','skip');
    };
    isModalSkipped(){
        return localStorage.getItem('allow-chat-popup-modal')
    }

    showPopupBlockedModal(){
        let rec = this;
        let checkBox=$('<input/>',{
            id:'do-not-show-popup-checkbox',
            type:'checkbox'
        });
        let checkboxStyled=$("<div/>",{
            class:"round",
            html:[checkBox,`<label for="do-not-show-popup-checkbox"></label>`]
        })
        let dontShowModlaLabel=$('<label/>',{
            html:'Do not show again',
            for:'do-not-show-popup-checkbox'
        });
        let dontShowCheckCont=$('<div/>',{
            class:'do-not-show-check-container styled-checkbox noselect',
            html:[checkboxStyled,dontShowModlaLabel]
        });
        let tipModalFooterCancel = $('<button/>',{
            class: 'btn kino-btn-primary',
            type: 'button',
            // 'data-dismiss': 'modal',
            html: 'Continue'
        }).on('click',()=>{
            if(checkBox.is(':checked')){
                rec.setModalShown();
            }
            rec.adModal.modal('hide');
            // rec.openPopup();
        });
        let tipModalFooter = $('<div/>',{
            class: 'modal-footer border-0 pt-0 popup-blocked-footer',
            html: [dontShowCheckCont,tipModalFooterCancel]
        });

        let tipModalBodyHeader = $('<p/>',{
           class: 'text-center mt-2',
           id: 'kino-recorder-text-1',
           html: `<p>When recording or live streaming, the chat will show in a window outside of the main Kino window.</p>
           <p>We detected a pop-up blocker that prevents the chat window from showing up.
           Disable the pop-up blocker or allow Kino to show chat outside of the main screen.</p>`
        });

        let tipModalBodySubHeader = $('<h3/>',{
            class: 'mt-2 text-center',
            id: 'kino-recorder-text-2',
            html: `Chat pop-up blocked`
        });

        // let tipModalBodyBottomText = $('<p/>',{
        //     class: 'font-weight-bold text-center',
        //     id: 'kino-recorder-text-3',
        //     html: `<u>${rec.modalBodyBottomText}</u>`
        // });

        let method1=$('<ul/>',{
            class:'guide-list',
            html:[
                `<li>In the address bar, click Pop-up blocked <img src="${isElectron ? '../..' : ''}/images/popup-blocked.png"> icon</li>`,
                `<li>Select <b>Always allow pop-ups and redirects from https://kino.live</b> then click <b>Done</b></li>`
            ]
        });
        let method2=$('<ul/>',{
            class:'guide-list',
            html:[
                '<li>On the top left of the web address, click the lock <i class="fas fa-lock"></i> icon</li>',
                `<li>Click ${isEdge ? '<svg width="20" height="20" viewBox="0 0 20 20" class="c011471 "><path d="M15 6a1 1 0 11-2 0 1 1 0 012 0z"></path><path d="M12.5 2a5.45 5.45 0 00-5.38 6.67c.06.27 0 .5-.14.64l-4.54 4.54A1.5 1.5 0 002 14.91v1.59c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h1a1 1 0 001-1v-1h1a1 1 0 001-1v-.18c.5.13 1 .18 1.5.18 3.08 0 5.5-2.42 5.5-5.5S15.58 2 12.5 2zM8 7.5C8 4.98 9.98 3 12.5 3S17 4.98 17 7.5 15.02 12 12.5 12c-.66 0-1.27-.1-1.78-.35a.5.5 0 00-.72.45v.9H9a1 1 0 00-1 1v1H7a1 1 0 00-1 1v.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1.59a.5.5 0 01.15-.35l4.54-4.54c.43-.43.52-1.04.4-1.56-.06-.3-.09-.63-.09-.96z"></path></svg> <b>Permissions for this site</b>': '<i class="fas fa-cog"></i> <b>Site settings</b>'}</li>`,
                `<li>Scroll down to <b>Pop-ups and redirects</b> and change to <b>Allow</b></li>`
            ]
        })
        let guideContainer=$("<div/>",{
            class:'guide-container',
            html:[`<div class="method-title pb-0">Method one</div>`,method1,`<div class="method-title">Method two</div>`,method2]
        })

        let showEnablePopupGuideBtn=$('<button/>',{
            class:'btn kino-btn-secondary show-guide-button',
            html:`Allow Kino pop-ups on Chrome&nbsp;<svg fill="none" height="10" width="10" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.07.248a.75.75 0 111.115 1.004L5.656 5.193a.75.75 0 01-1.115 0L1.068 1.252A.75.75 0 012.182.248L5.1 3.571 8.07.248z" fill="#032836"></path>
                </svg>`
        }).on('click',()=>{
            guideContainer.toggleClass('open');
            showEnablePopupGuideBtn.toggleClass('guide-shown')
        });

        let allowPopupsGuide=$("<div/>",{
            class:'allow-popups-guide',
            html:[showEnablePopupGuideBtn,guideContainer]
        });
        let tipModalBodyWrapper = $('<div/>',{
            class: 'px-1 kino-recorder-modal-body',
            html: [`<img src="${isElectron ? '../..' : ''}/images/chat-popup.png" id="popup-blocked-window-img"/>`,tipModalBodySubHeader,tipModalBodyHeader,allowPopupsGuide]
        })

        let tipModalBody = $('<div/>',{
            class: 'modal-body pt-0',
            html: [tipModalBodyWrapper]
        });

        let tipModalTitle = $('<h4/>',{
            class: 'modal-title text-center mb-2',
            id: '',
            html: rec.modalTitle
        });

        // let tipModalSubTitle = $('<span/>',{
        //     class: '',
        //     id: '',
        //     html: rec.modalSubHeader
        // });

        let tipCloseModalBtn = $('<button/>',{
            class: 'close-button-modal-kino',
            type: 'button',
            'data-dismiss': 'modal',
            'aria-label': 'Close',
            html: rec.closeModalBtn
        });

        let tipModalHeader = $('<div/>',{
            class: 'modal-header modal-header-kino',
            html: [tipModalTitle, tipCloseModalBtn]
        });

        let tipModalContent = $('<div/>',{
            class: 'modal-content',
            html: [tipModalHeader, tipModalBody, tipModalFooter]
        });

        let tipModalWrapper = $('<div/>',{
            class: 'modal-dialog',
            role: 'document',
            style: '',
            html: [tipModalContent]
        });

        rec.adModal = $('<div/>',{
            class: 'modal modal-inside-kino fade',
            id: 'start-recording-adBlocker-modal',
            tabindex: '-1',
            role: 'dialog',
            'aria-labelledby': 'start-recording-adBlocker-modal-modalCenterTitle',
            'aria-hidden': 'true',
            'data-keyboard': 'false',
            'data-backdrop': 'static',
            html: [tipModalWrapper]
        });

        rec.adModal.modal();
    };

};
